import "./partners-companies.css";

function PartnerCompanies() {
  return (
    <div className="partner-companies-section">
      <h1>We totally deliver!</h1>
      <p>Here’s the quick rundown.</p>

      <div className="partner-companies">
        <img
          src="/assets/icons/partner-companies-logos/hyundai.svg"
          alt="Hyundai Logo"
        />
        <img
          src="/assets/icons/partner-companies-logos/vittaverse-2.svg"
          alt="Vittaverse Logo"
        />
        <img
          src="/assets/icons/partner-companies-logos/aromateque.svg"
          alt="Aromateque Logo"
        />
        <img
          src="/assets/icons/partner-companies-logos/benefits.svg"
          alt="Benefits Logo"
        />
        <img
          src="/assets/icons/partner-companies-logos/koncepted.svg"
          alt="Koncepted Logo"
        />
        <img
          src="/assets/icons/partner-companies-logos/upgaming.svg"
          alt="Upgaming Logo"
        />
        <img
          src="/assets/icons/partner-companies-logos/palitranews.svg"
          alt="Palitranews Logo"
        />
        <img
          src="/assets/icons/partner-companies-logos/joma.svg"
          alt="Joma Logo"
        />
        <img
          src="/assets/icons/partner-companies-logos/fahrlygo.svg"
          alt="Fahrlygo Logo"
        />
        <img
          src="/assets/icons/partner-companies-logos/nespola.svg"
          alt="Nespola Logo"
        />
        <img
          src="/assets/icons/partner-companies-logos/mobu-3.svg"
          alt="Mobu Logo"
        />
        <img
          src="/assets/icons/partner-companies-logos/material.svg"
          alt="Material Logo"
        />
      </div>
    </div>
  );
}

export default PartnerCompanies;
